import HeroSection from '@/components/sections/partners/HeroSection';
import ServicesSection from '@/components/sections/partners/ServicesSection';
import TargetSection from '@/components/sections/partners/TargetSection';
import RemunerationSection from '@/components/sections/partners/RemunerationSection';
import ProcessSection from '@/components/sections/partners/ProcessSection';
import CTASection from '@/components/sections/partners/CTASection';
import SEO from '@/components/SEO';
import FAQ from '@/components/ui/FAQ';
import ProjectsSection from '@/components/sections/partners/ProjectsSection';

const Partenaires = () => {
  const faqItems = [
    {
      question: "Comment puis-je devenir partenaire d'Orcsys ?",
      answer: "Le processus est simple : contactez-nous via email ou téléphone, nous organiserons un entretien pour discuter de vos objectifs et de la meilleure façon de collaborer. Nous vous accompagnerons ensuite dans la mise en place de notre partenariat."
    },
    {
      question: "Quels sont les critères pour qu'un lead soit considéré comme qualifié ?",
      answer: "Un lead qualifié doit répondre à tous les critères essentiels : avoir un budget minimum de 5 000€, être basé en France métropolitaine, être le décideur ou avoir une influence directe, et avoir une date de début prévue dans les 3 mois. Il doit également répondre à au moins 2 critères complémentaires parmi ceux définis plus haut."
    },
    {
      question: "Comment suis-je rémunéré pour les leads qualifiés ?",
      answer: "Pour chaque lead qualifié, vous recevez une rémunération fixe versée sous 7 jours après qualification. Pour les contrats conclus, vous recevez un pourcentage du montant du contrat, variable selon le type de projet et son montant."
    },
    {
      question: "Puis-je être partenaire si je ne suis pas dans le secteur du numérique ?",
      answer: "Absolument ! Nous recherchons des partenaires de tous horizons. Votre réseau et votre capacité à identifier des opportunités sont plus importants que votre secteur d'activité."
    },
    {
      question: "Comment le suivi des leads et des contrats est-il effectué ?",
      answer: "Nous utilisons un système transparent de suivi où vous pouvez voir l'état d'avancement de chaque lead ou projet. Vous recevez des mises à jour régulières et êtes informé dès qu'un lead est qualifié ou qu'un contrat est signé."
    }
  ];

  return (
    <>
      <SEO 
        title="Devenez Partenaire Orcsys"
        description="Rejoignez notre réseau de partenaires et développez votre activité en collaborant avec Orcsys. Opportunités de rémunération attractives pour les leads qualifiés et les contrats conclus."
        keywords="partenariat, leads qualifiés, commission, développement web, applications mobiles, solutions digitales, opportunités business"
        type="page"
        url="https://innov.orcsys.fr/partenaires"
        image="https://innov.orcsys.fr/images/partners-preview.png"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <ServicesSection />
        <TargetSection />
        <ProjectsSection />
        <RemunerationSection />
        <ProcessSection />
        <FAQ 
          title="Questions Fréquentes sur le Partenariat"
          subtitle="Tout ce que vous devez savoir pour devenir partenaire Orcsys"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default Partenaires; 